import type { FrictionSnapshot } from "../types/friction-finder";
import { formatAustralianDate } from "../lib/generateSnapshot";
import { PrintWordmark } from "./BrandHeader";
import { m, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

export function SnapshotView({ snapshot, actions }: { snapshot: FrictionSnapshot; actions?: ReactNode }) {
  const reduceMotion = useReducedMotion();
  const reveal = (delay = 0) => ({
    initial: reduceMotion ? false as const : { opacity: 0.72, y: 5 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: reduceMotion ? 0 : 0.2, delay: reduceMotion ? 0 : delay, ease: [0.22, 1, 0.36, 1] as const },
  });
  return (
    <m.article className="snapshot-card" aria-labelledby="snapshot-title" data-motion-region="snapshot" {...reveal()}>
      <PrintWordmark />
      <div className="snapshot-heading-row">
        <div className="snapshot-title-lockup">
          <h1 id="snapshot-title" tabIndex={-1}>{snapshot.title}</h1>
          <span className={`intent-badge intent-badge--${snapshot.intent === "Fixing Today" ? "fixing" : "planning"}`}>{snapshot.intent}</span>
        </div>
        {actions}
      </div>
      <m.p className="snapshot-summary" {...reveal(0.04)}>{snapshot.summary}</m.p>
      <m.section {...reveal(0.07)}>
        <h2>{snapshot.impactHeading}</h2>
        <p>{snapshot.impactStatement}</p>
      </m.section>
      <m.section {...reveal(0.1)}>
        <h2>{snapshot.desiredStateHeading}</h2>
        <p>{snapshot.desiredStateStatement}</p>
      </m.section>
      <m.section {...reveal(0.13)}>
        <h2>{snapshot.nextStepHeading}</h2>
        <p>{snapshot.nextStepStatement}</p>
      </m.section>
      <p className="generated-date print-only">Generated {formatAustralianDate(snapshot.generatedAt)}</p>
    </m.article>
  );
}
